export enum BlogPostBackgroundColor {
  linen = 'linen',
  olivine = 'olivine',
  white = 'white',
  aquaSpring = 'aquaSpring'
}
